import { PlanFeature, PlanLimit, SubscriptionPlan } from '@next-is-free-monorepo/next-is-free-types';
import useShopAttrs from '../utils/hooks/useShopAttrs';
import { ReactNode, useState, forwardRef, useImperativeHandle } from 'react';
import { HugeiconsIcon } from '@hugeicons/react';
import {
  CircleUnlockIcon,
  FileLockedIcon,
  LockedIcon,
  Locker01FreeIcons,
  LockIcon,
  SquareLock01FreeIcons, SquareUnlock01FreeIcons
} from '@hugeicons/core-free-icons';
import CModal from './CModal';
import { IconArrowUp } from '@tabler/icons-react';
import {
  isPlanFeature,
  isPlanLimit,
  planFeatures,
  planGetLimit
} from '@next-is-free-monorepo/next-is-free-shared-utils';
import { NModal } from '@next-is-free-monorepo/nif-web-components';
import ChoosePlanModal from './billings/ChoosePlanModal';

interface PlanGateProps {
  featureKey: PlanLimit | PlanFeature,
  hideMask?: boolean,
  currentNumber?: number,
  fallbackComponent?: ReactNode,
  children: ReactNode,
  devSimulateBlocked?: boolean
}

export interface PlanGateRef {
  triggerUpgradeModal: () => void;
}


const PlanGate = forwardRef<PlanGateRef, PlanGateProps>(({ featureKey, hideMask = false, currentNumber, fallbackComponent, children, devSimulateBlocked = false }, ref) => {

  const { data } = useShopAttrs();
  const [upgradeModalOpen, setUpgradeModalOpen] = useState(false);
  const [choosePlanModal, setChoosePlanModal] = useState(false);

  useImperativeHandle(ref, () => ({
    triggerUpgradeModal: () => {
      setUpgradeModalOpen(true);
    }
  }));

  let isAllowedPlan = false;

  // Development mode: simulate blocked feature
  if (devSimulateBlocked && process.env.NODE_ENV === 'development') {
    isAllowedPlan = false;
  } else {
    if (isPlanFeature(featureKey)) {
      isAllowedPlan = planFeatures(data.subscription_plan, featureKey);
    } else if (isPlanLimit(featureKey) && currentNumber !== undefined) {
      isAllowedPlan = planGetLimit(data.subscription_plan, featureKey) >= currentNumber + 1;
    } else {
      return <>{children}</>;
    }
  }

  return (
    <>
      {isAllowedPlan ? <>{children}</> : fallbackComponent ? (fallbackComponent) :
        <div className={`relative overflow-hidden ${!hideMask && 'rounded-xl border'}`}>
          <div onClick={() => setUpgradeModalOpen(true)}
               className={`absolute cursor-pointer top-0 left-0 w-full h-full flex items-center justify-center gap-1 ${!hideMask && 'bg-gradient-to-r from-slate-100/50 via-slate-100/40 to-slate-100/50'} text-slate-500 z-10`}>
            {
              !hideMask && <div className={'flex items-center gap-1 hover:text-indigo-600'}>
                <HugeiconsIcon icon={SquareLock01FreeIcons} size={18} />
                Sblocca
              </div>
            }
          </div>
          <div className={`${!hideMask ? 'blur-[5px]' : undefined}`}>
            {children}
          </div>
        </div>
      }
      <NModal color={'green'} hugeIcon={SquareUnlock01FreeIcons} open={upgradeModalOpen} title={'Sblocca questa funzione'}
              text={'Il tuo piano attuale non ti permette di usufruire di questa funzione, passa ad un piano superiore per sbloccarla.'}
              confirmButtonText={'Vedi Piani'}
              onClose={() => setUpgradeModalOpen(false)} icon={<IconArrowUp />} onConfirm={() => {setUpgradeModalOpen(false); setChoosePlanModal(true)}}>
      </NModal>
      <ChoosePlanModal open={choosePlanModal} onClose={() => setChoosePlanModal(false)}  />
    </>
  );
});

PlanGate.displayName = 'PlanGate';
export default PlanGate;
